import React from 'react';
import PropTypes from 'prop-types';
import Value from '../Value/Value';
import { StyledDataInvolvedItem } from './DataInvolvedItemStyles';

const DataInvolvedItem = ({
  data: { RecordSource: source, RecordType: type, RecordInformation: information },
  isInList,
}) => (
  <StyledDataInvolvedItem isInList={isInList}>
    {!!source && <Value label="Source">{source}</Value>}
    {!!type && <Value label="Category">{type}</Value>}
    {!!information && <Value label="Data Involved">{information}</Value>}
  </StyledDataInvolvedItem>
);

DataInvolvedItem.defaultProps = {
  isInList: false,
};

DataInvolvedItem.propTypes = {
  data: PropTypes.shape({
    RecordSource: PropTypes.string,
    RecordType: PropTypes.string,
    RecordInformation: PropTypes.string,
  }).isRequired,
  isInList: PropTypes.bool,
};

export default DataInvolvedItem;
